import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PageService } from '../services/page.service';
import CryptoJS from 'crypto-js'
import { Location } from '@angular/common';

@Component({
    selector: 'app-ve-verify',
    templateUrl: './ve-verify.component.html',
    styleUrls: ['./ve-verify.component.scss'],
})
export class VeVerifyComponent implements OnInit {

  @Input() data;
  @Input() controls;
  @Input() config;

  

  public isOwner: boolean = true;
  public isWalletConnected: boolean = false;
  public isLoading: boolean = false;
    url: string;
    redirectionUrl: string;
    walletAddress: string;
    constructor() {
        const url: string = window.location.href;
        const urlObj = new URL(url);

        if(urlObj.searchParams.has('vnt') || urlObj.searchParams.has('w')){
            //Removing params from url
            if (urlObj.searchParams.has('vnt')) {
                urlObj.searchParams.delete('vnt');
            }
            if(urlObj.searchParams.has('w')){
                urlObj.searchParams.delete('w');
            }
            const cleanUrl = urlObj.toString();
            window.history.replaceState({}, '', cleanUrl);
         }
    }
        

    public ngOnInit(): void {

        if(this.data?.entityInformation?.walletAddress){
            this.isWalletConnected = true;
            this.walletAddress = this.data?.entityInformation?.walletAddress.substring(0,6) + '...' + this.data?.entityInformation?.walletAddress.slice(-4);
            if(!this.config.veWorldAddress){
               this.isOwner = false;
            }
        }else{
            this.isWalletConnected = false;
        }

          

        if(!this.controls && !this.config) this.isOwner = false;

        let domain = window.location
        
        let url = domain.origin;
        let urlForRedirect = domain.href;
        let encodeUrl = new URL(urlForRedirect);
        if (encodeUrl.searchParams.has('w')) {
            encodeUrl.searchParams.delete('w');
        }
        let redirectUrl = encodeUrl.toString();
        let secretKey = 'origin';
      
        let encryptedData = CryptoJS.AES.encrypt(redirectUrl, secretKey).toString();
        const urlSafeEncodedData = btoa(encryptedData);
        if(this.config.nt){
            const encodedNt = encodeURIComponent(this.config.nt);
            this.redirectionUrl = `${url}/vconnect/wallet?or=${urlSafeEncodedData}&vnt=${encodedNt}`; 
            
        }else{
            this.redirectionUrl = `${url}/vconnect/wallet?or=${urlSafeEncodedData}`;
            
        }
    }
   

    public openModal(): void {
        location.href = this.redirectionUrl;
    }

    public disconnectWallet():void {
 
       let simplifiedUrl = `${this.redirectionUrl}&disconnect=true`; // Modify the query string directly
       if(this.config?.nt){
            const encodedNt = encodeURIComponent(this.config.nt);
            simplifiedUrl = `${this.redirectionUrl}&disconnect=true&vnt=${encodedNt}`;
       }
       const finalUrl = new URL(simplifiedUrl); // Create a new URL object from the modified string
       window.location.href = finalUrl.toString();
    }

}
